import { apiClient, Auth } from '@/shared/api'

import { TLastActiveContract } from '../model/schema'

export type GetLastActiveContractParams = {
  roomId: number
}

type GetLastActiveContractResponse = {
  lastActiveContract: TLastActiveContract | null
}

export const getLastActiveContract = async ({
  roomId,
}: GetLastActiveContractParams) => {
  const response = await apiClient.get<GetLastActiveContractResponse>({
    endpoint: '/guest/contracts/last-active',
    queryParams: { rid: roomId },
    auth: Auth.REQUIRED,
  })

  return response
}
